import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encodedData = params.get("data");

    if (encodedData) {
      try {
        const decodedData = JSON.parse(decodeURIComponent(encodedData));
        localStorage.setItem("token", decodedData.token);
        localStorage.setItem("user", JSON.stringify(decodedData));
        localStorage.setItem("userId", decodedData.userId);
        

        // 👇 ADD THIS LINE
        if (decodedData.name) {
          localStorage.setItem("userName", decodedData.name);
        }

        setTimeout(() => {
          navigate("/");
        }, 1000);
      } catch (error) {
        console.error("Failed to parse data:", error);
      }
    } else {
      console.error("No data found in callback URL");
      navigate("/login");
    }
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>Authenticating...</h2>
      <p>Please wait while we log you in.</p>
    </div>
  );
};

export default AuthCallback;
